export type CapitalGlobalProposalAddressFieldPrefix =
  | 'registration'
  | 'correspondence';

export const CAPITAL_GLOBAL_PROPOSAL_ADDRESS_FIELD_NAMES = {
  registration: {
    cep: 'registrationCep',
    street: 'registrationStreet',
    number: 'registrationNumber',
    complement: 'registrationComplement',
    neighborhood: 'registrationNeighborhood',
    city: 'registrationCity',
    state: 'registrationState',
  },
  correspondence: {
    cep: 'correspondenceCep',
    street: 'correspondenceStreet',
    number: 'correspondenceNumber',
    complement: 'correspondenceComplement',
    neighborhood: 'correspondenceNeighborhood',
    city: 'correspondenceCity',
    state: 'correspondenceState',
  },
} as const satisfies Record<
  CapitalGlobalProposalAddressFieldPrefix,
  Record<string, string>
>;

/**
 * Nomes dos campos de um bloco de endereço, já no formato de path do TanStack Form.
 * O prefixo fixo (`registration`/`correspondence`) usa chaves planas; o subestipulante
 * usa acessor de array (`subStipulatorAddresses[i].cep`), suportado nativamente por
 * `DeepKeys` (`ArrayAccessor` no form-core).
 */
export type CapitalGlobalAddressFieldNames = {
  cep: string;
  street: string;
  number: string;
  complement: string;
  neighborhood: string;
  city: string;
  state: string;
};

/** Campos de endereço do subestipulante de índice `index`. */
export function capitalGlobalSubStipulatorAddressFieldNames(
  index: number
): CapitalGlobalAddressFieldNames {
  const base = `subStipulatorAddresses[${index}]` as const;
  return {
    cep: `${base}.cep`,
    street: `${base}.street`,
    number: `${base}.number`,
    complement: `${base}.complement`,
    neighborhood: `${base}.neighborhood`,
    city: `${base}.city`,
    state: `${base}.state`,
  };
}

export const CAPITAL_GLOBAL_CORRESPONDENCE_VALIDATE_FIELD_NAMES = [
  'correspondenceCep',
  'correspondenceStreet',
  'correspondenceNumber',
  'correspondenceNeighborhood',
  'correspondenceCity',
  'correspondenceState',
] as const;
